import {
  useRef,
  useEffect,
  useState,
  cloneElement,
  isValidElement,
} from "react";
import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";
import { emptyValueFormatter } from "../../utils/Utils";

const TooltipRenderer = ({
  title,
  children,
  placement = "bottom",
  formatter = emptyValueFormatter,
}) => {
  const cellRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const displayValue = formatter({ value: title }) || "-";

  const checkOverflow = (element) => {
    if (!element) {
      return false;
    }

    const scrollWidth = element.scrollWidth || 0;
    const clientWidth = element.clientWidth || 0;

    return scrollWidth - clientWidth > 1;
  };

  useEffect(() => {
    if (cellRef.current) {
      const element = cellRef.current;
      setIsOverflowing(checkOverflow(element));
    }
  }, [displayValue]);

  const tooltipStyles = {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  };

  const renderChildren = () => {
    if (isValidElement(children)) {
      return cloneElement(children, { ref: cellRef, style: tooltipStyles });
    }
    return (
      <span ref={cellRef} style={tooltipStyles}>
        {displayValue}
      </span>
    );
  };

  return (
    <CustomTooltip
      text={isOverflowing ? displayValue : ""}
      placement={placement}
    >
      {renderChildren()}
    </CustomTooltip>
  );
};

export default TooltipRenderer;
